module.exports = __webpack_public_path__ + "static/media/dot_0FBB58_a.c989a1fa.svg";